const kr = {
	login: 'Accesso',
	logout: 'Disconnettersi',
	signin: 'registrati',
	signup: 'Iscriviti',
	email: 'e-mail',
	emailAddr: 'Indirizzo email',
	password: 'parola d\'ordine',
	rememberMe: 'Ricordati di me',
	forgotYourPwd: 'Hai dimenticato la password?',
	signinFacebook: 'Accedi con Facebook',
	signinGoogle: 'Accedi con Google',
	dontAccount: 'Non hai un account?',
	firstName: 'Nome di battesimo',
	lastName: 'Cognome',
	confirmPwd: 'conferma password',
	signup_msg: 'Facendo clic su Iscriviti ora, accetti il',
	digitX_user_agreement: 'Accordo con l\'utente di DigitXchange',
	privacy_policy: 'politica sulla riservatezza',
	and: ' e ',
	cookies_policy: 'Politica sui cookie',
	have_account: 'Hai già un account',
	forgotPwd: 'Dimenticare la password',
	recoverPwd: 'RECUPERA LA PASSWORD',
	forgotPwd_msg: 'Inserisci la tua email nel campo sopra, ti invieremo un link con le istruzioni da seguire.',
	changePwd: 'Cambia la password',
	oldPwd: 'vecchia password',
	newPwd: 'nuova password',
	confirmNewPwd: 'Conferma la nuova password',
	user_account: 'Account utente',
	change_pic: 'Cambia immagine',
	mobile_number: 'Numero di cellulare',
	country: 'Nazione',
	update_settings: 'aggiorna impostazioni',
	company: 'Azienda',
	aboutUs: 'Riguardo a noi',
	tos: 'TOS',
	copyright: 'Diritto d\'autore',
	socialMedia: 'Social media',
	forUpdates: 'per aggiornamenti',
	footer_msg_1: 'Registrandoti accetti',
	terms: 'Termini di servizio',
	contactUs: 'Contattaci',
	yourEmail: 'La tua email',
	required: 'necessario',
	yourMsg: 'Il tuo messaggio',
	sent: 'Inviato',
	footer_msg_2: 'Tutti i diritti riservati',
	footer_msg_3: 'Tutti i nomi di prodotti, marchi e marchi registrati sono di proprietà dei rispettivi proprietari',
	doom: 'Doom III',
	filter: 'Filtro',
	add_asset: 'Aggiungi risorsa',
	request_game: 'Richiedi gioco',
	search_msg: 'Siamo spiacenti, ma nulla corrisponde ai tuoi termini di ricerca.',
	post: 'Inviare',
	asset: 'Risorsa',
	create: 'Creare',
	character: 'Personaggio',
	characters: 'Personaggi',
	assets: 'Risorse',
	profile: 'Profilo',
	game: 'Gioco',
	games: 'Giochi',
	currency: 'Moneta',
	store: 'Memorizzare',
	all_time: 'Sempre',
	this_month: 'Questo mese',
	trending: 'Trending',
	item_name: 'Nome dell\'oggetto',
	view_item: 'Visualizza oggetto',
	leaderboard: 'Classifica',
	posters: 'Poster',
	chinese: 'Cinese',
	english: 'Inglese',
	japanese: 'giapponese',
	korean: 'coreano',
	german: 'Tedesco',
	french: 'francese',
	spanish: 'spagnolo',
	italian: 'italiano',
	russian: 'russo',
	portuguese: 'portoghese',
	hindi: 'hindi',
	arabic: 'Arabo',
	buy: 'Acquistare',
	subscription: 'Sottoscrizione',
	buy_subscription: 'Acquista l\'abbonamento',
	gift: 'Regalo',
	xchange: 'Xchange',
	subscription_plan: 'Piano di abbonamento',
	payment_options: 'Opzioni di pagamento',
	cardholder_name: 'Nome del titolare',
	submit_order: 'Inviare ordine',
	card_number: 'Numero di carta',
	cvv: 'CVV',
	expiration_date: 'Data di scadenza',
	buyXchange: 'Acquista Xchange',
	giftXchange: 'Scambio regalo',
	or: 'o',
	select: 'Selezionare',

	search: 'Ricerca',
	search_games: 'Cerca giochi ...',
	search_assets: 'Cerca risorse ...',
	platform: 'piattaforma',
	total_posts: 'Messaggi totali',
	total_comments: 'Commenti totali',
	total_characters: 'Personaggi totali',
	total_assets: 'Totale attivo',
	xchange_currency: 'Valuta Xchange',
	subscription_days_remaining: 'Giorni di abbonamento rimanenti',
	total_asset_networth: 'Totale delle attività verso il Nord',
	total_character_networth: 'Total Character Networth',
	most_downloaded: 'Il più scaricato',
	recently_added: 'Aggiunto recentemente',
	genre: 'Genere',
	my_library: 'La mia biblioteca',
	most_commented: 'più commentato',
	most_recent: 'Piu recente',
	nearing_addition: 'In arrivo aggiunta',
	create_asset: 'Crea risorsa',
	create_character: 'Crea personaggio',
	asset_name: 'Nome del bene',
	asset_type: 'Tipo di risorsa',
	rarity: 'Rarità',
	enhancements: 'miglioramenti',
	add: 'Inserisci',
	currency_type: 'Tipo di valuta',
	price: 'Prezzo',
	description: 'Descrizione',
	upload_asset: 'Carica risorsa',
	preview_asset: 'Anteprima delle risorse',
	main_image: 'Immagine principale',
	upload_video: 'Carica video',
	upload: 'Caricare',
	view_demo: 'Visualizza la demo',
	character_name: 'Nome del personaggio',
	character_type: 'Tipo di carattere',
	upload_character: 'Carica personaggio',
	preview_character: 'Anteprima personaggio',
	race: 'Gara',
	class: 'Classe',
	gender: 'Genere',
	level: 'Livello',
	showing: 'Mostrando',
	of: 'di',
	results: 'risultati',
	featured_characters: 'Personaggi in primo piano',
	url: 'URL',
	submit: 'Invia',
	real_world: 'Mondo reale',
	game_currency: 'Valuta del gioco',
	all: 'Tutti',
	
	edit: 'modificare',
	save: 'Salva',
	agg_character_networth: 'Personaggio aggregato Networth',
	agg_time_played: 'Tempo aggregato giocato',
	agg_asset_value: 'Valore patrimoniale aggregato',
	enter_character_creation_date: 'Inserisci la data di creazione del personaggio',
	in_game_currency: 'Nella valuta del gioco',
	real_world_value: 'Valore reale',
	update_character: 'Aggiorna personaggio',
	item_not_found: 'Articolo non trovato!',
	ripper: 'squartatore',
	comments: 'Commenti',
	add_comments: 'Aggiungi commenti',
	new_suggested_price: 'Nuovo prezzo suggerito',
	sort_by: 'Ordina per',
	reply: 'rispondere',
	asset_networth: 'Asset Networth',
	join_date: 'Data di iscrizione',
	report: 'rapporto',
	first: 'Primo',
	last: 'Scorso',
	most_replies: 'La maggior parte delle risposte',
	new_pricing_recommendations: 'Nuovi consigli sui prezzi',
	xchange_amount: 'Importo Xchange',
	username: 'Nome utente',
	send_gift: 'Invia REGALO',
	message: 'Messaggio',
	gift_text: 'Personalizza il tuo messaggio qui',
	day: 'giorno',
	days: 'giorni',
	currency_converter: 'Convertitore di valuta',
	from: 'A partire dal',
	to: 'Per',
	in_game: 'In gioco',
	real_life: 'Vita reale',
	cvc: 'CVC',
	card: 'Carta',
	per_month: 'Mensile ($ 3 al mese)',
	per_year: 'Annuale ($ 30 all\'anno)',
	aboutUs_text: 'DigitXChange è un sito web guidato dalla comunità che mira a dare finalmente un valore al valore di beni e servizi digitali tramite il crowdfunding. Se hai mai posto la domanda "quanto vale veramente il mio personaggio" o "Mi chiedo quale sarebbe un commercio equo con un altro giocatore in un altro gioco", non cercare più le risposte. Ci auguriamo che il nostro sito ti piaccia, partecipi alla costruzione della conoscenza del gruppo, mostri il tuo bottino guadagnato duramente e alla fine non vediamo l\'ora di scoprire il tuo patrimonio digitale totale!',
	home: 'Homepage',
	all_time_characters: 'Personaggi di tutti i tempi',
	this_month_characters: 'Personaggi di questo mese',
	trending_characters: 'Personaggi di tendenza',
	all_time_posters: 'Poster di tutti i tempi',
	this_month_posters: 'Poster di questo mese',
	trending_posters: 'Poster di tendenza',

};

export default kr;


// WEBPACK FOOTER //
// ./src/translations/it.js